export interface CurrencyPrecisionSettings {
  decimal_places?: number | string | null;
}

export const currencyDecimalPlaces = (settings?: CurrencyPrecisionSettings | null): number => {
  const value = Number(settings?.decimal_places ?? 0);
  const safeValue = Number.isFinite(value) ? value : 0;

  return Math.trunc(Math.max(0, Math.min(safeValue, 4)));
};

export const roundCurrencyAmount = (
  value: number | string | null | undefined,
  settings?: CurrencyPrecisionSettings | null
): number => {
  const numeric = Number(value || 0);

  if (!Number.isFinite(numeric)) {
    return 0;
  }

  const decimalPlaces = currencyDecimalPlaces(settings);
  const factor = 10 ** decimalPlaces;
  const sign = numeric < 0 ? -1 : 1;

  return sign * (Math.round((Math.abs(numeric) + Number.EPSILON) * factor) / factor);
};

export const currencyAmountDifference = (
  amount: number | string | null | undefined,
  total: number | string | null | undefined,
  settings?: CurrencyPrecisionSettings | null
): number => {
  const difference = roundCurrencyAmount(amount, settings) - roundCurrencyAmount(total, settings);

  return roundCurrencyAmount(Math.max(difference, 0), settings);
};

export const isCurrencyAmountAtLeast = (
  amount: number | string | null | undefined,
  total: number | string | null | undefined,
  settings?: CurrencyPrecisionSettings | null
): boolean => roundCurrencyAmount(amount, settings) >= roundCurrencyAmount(total, settings);
